import { IconProps } from '../../modules/icons/IconProps';
export function ThermometerState5(props: IconProps) {
    return (
        <svg
            {...props}
            width="80"
            height="354"
            viewBox="0 0 80 354"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M40 0C51.0457 0 60 8.95431 60 20V279.353C71.9557 286.269 80 299.195 80 314C80 336.091 62.0914 354 40 354C17.9086 354 0 336.091 0 314C0 299.195 8.04427 286.269 20 279.353V20C20 8.95431 28.9543 0 40 0Z"
                fill="#F5F5F5"
            />
            <path
                d="M40 4C48.8366 4 56 11.1634 56 20V281.744C67.8533 287.635 75.9999 299.866 76 314C76 333.882 59.8823 350 40 350C20.1177 350 4 333.882 4 314C4.00009 299.866 12.1467 287.635 24 281.744V20C24 11.1634 31.1634 4 40 4Z"
                fill="url(#paint0_linear_613_1132)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_613_1132"
                    x1="40"
                    y1="38"
                    x2="40"
                    y2="353.27"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FEAEB5" />
                    <stop offset="0.350962" stop-color="#FFC499" />
                    <stop offset="1" stop-color="#B0E2C4" />
                </linearGradient>
            </defs>
        </svg>
    );
}
